import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import routes from '../config/routes';
import { useEnterpriseAuth } from '../context/EnterpriseAuthContext';
import { CircularProgress, Box } from '@mui/material';

export default function ProtectedRoute({ user, children }) {
  const { isLoading, isAuthenticated, user: authUser } = useEnterpriseAuth();
  const location = useLocation();
  
  console.log('[ProtectedRoute]', location.pathname, { isLoading, isAuthenticated, user, authUser });
  
  // Show loading spinner while auth is being checked
  if (isLoading) {
    console.log('[ProtectedRoute] Showing loading spinner');
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  // Use either the passed user prop or the auth context user
  const currentUser = user || authUser;
  
  console.log('[ProtectedRoute] Current user:', currentUser);
  
  // Only redirect if auth check is complete and user is not authenticated.
  // Regardless of any stale token/user in localStorage, push to the correct login.
  if (!currentUser && !isAuthenticated) {
    console.log('[ProtectedRoute] Redirecting to login - no user or not authenticated');
    const redirectTo = location.pathname.startsWith('/patient')
      ? routes.login()
      : location.pathname.startsWith('/asc')
      ? routes.ascLogin()
      : routes.login();
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }
  
  return children;
}
